import { createDynamicMiddleware } from "@reduxjs/toolkit/react";

import type { AppDispatch, RootState } from "../@types";

type MiddlewareApiConfig = {
  state: RootState;
  dispatch: AppDispatch;
};

const dynamicMiddleware = createDynamicMiddleware();
const { middleware, addMiddleware, withMiddleware, createDispatchWithMiddlewareHook } = dynamicMiddleware;

const addAppMiddleware = addMiddleware.withTypes<MiddlewareApiConfig>();
const withAppMiddleware = withMiddleware.withTypes<MiddlewareApiConfig>();
const createAppDispatchWithMiddlewareHook = createDispatchWithMiddlewareHook.withTypes<MiddlewareApiConfig>();

export { addAppMiddleware, createAppDispatchWithMiddlewareHook, middleware, withAppMiddleware };
